import TickerAndStock from './tickerAndStock';

export default TickerAndStock;
